module.exports = __webpack_public_path__ + "static/illustration-2-88f510eeee84c0f64af383d860b53218.svg";